import React from 'react';
import './App.css';
import MenuBar from './common/menubar';
import MenuRouter from './common/menurouter';

import logo from './images/esmlogo.jpg';
import banner from './images/fmbanner.jpg';
import PageFooter from './components/footer';

import contactDetails from './resources/contactdetails.json';

function App() {
  return (
      <div className="App">
        <div className="menuContainer">
          <div style={{flex: 1, justifyItems: "center", alignItems: "center"}}>
            <img src={logo} height="40px" />
          </div>
          <div style={{flex: 8, justifyContent: "center", alignItems: "center"}}>
            <MenuBar />
          </div>
          <div style={{flex: 1}}></div>
        </div>
        <header style={{height: "200px", 
                        backgroundImage: "url("+ banner +")", 
                        backgroundSize: "100% 200px"}}></header>
        
        <div id="menu-router">
          <MenuRouter menuVisible={true} />
        </div>
        <footer>
          <hr />
          <PageFooter contactDetails={contactDetails} />
        </footer>
      </div>
  );
}

export default App;
